<template>
	<div  v-loading="loading" id="knowcollect">
		<Header></Header>
		<TwiceTitle></TwiceTitle>
		<div class="container">
			<div　class='none'  v-if="shop.length == 0">
				<img style="width:200px;height:250px" src="/static/image/null.svg" alt="">
				<div>非常抱歉！没有找到符合条件的商品!</div>
				<div style="font-size:14px;">您可以尝试：修改筛选条件或输入新的关键字重新查找</div>
			</div>
			<div v-for="item in shop" v-bind:key="item.id" class="shop-details">
				<div>
					<router-link style="text-decoration:none;color:#444444" :to="{path:'detail/'+item.id }">
					<img style="width:193px;height:195px;" v-lazy="lazyImg(item.cover_img)"  alt="">
					</router-link>
				</div>
				<div class="right-details">
					<div class="title"><router-link style="text-decoration:none;color:#444444" :to="{path:'detail/'+item.id }">{{item.title}}</router-link></div>
					<div class="star">
						<div>
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjxk.png" alt="">
						</div>
						<div class="condition">{{item.purity_name}}</div>
						<div class="address">所在地{{item.province}}省：{{item.city}}市</div>
					</div>
					<div class="shop-describe">
						{{item.description}}
					</div>
					<div class="foot-box">
						<div v-if="item.lowestprice == 0" class="money"  style="font-size:16px">暂无报价</div>
						<div v-if="item.lowestprice != 0" class="money"><span style="font-size:14px">￥</span>{{item.lowestprice}}</div>
						<div class="see-num">
							<!--<div class="pic"><img :src="item.bbs.user_avatar" alt="">  {{item.bbs.username}}</div>-->
							<div class="num"><img src="@/assets/liulan.png" alt=""> {{item.goods_hits}} 次</div>
							<div class="num"><img src="@/assets/msg.png" alt=""> {{item.comment_count}} 条</div>
							<div class="num"><img src="@/assets/sj.png" alt="">发布于{{item.create_time|time}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div v-if="shop.length != 0" class="pagination">
				<el-pagination
						background
						@current-change="changePage"
						:current-page="page"
						:page-size="12"
						layout="prev, pager, next"
						:total="total">
				</el-pagination>
				<span>共{{pagenum.last_page}}页</span>
			</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Foot from '@/components/common/Foot'
	import Header from '@/components/knowshop/Header'
	import TwiceTitle from '@/components/knowshop/TwiceTitle'
	import Mixin from '@/common/js/mixin'
	export default {
		mixins: [Mixin],
		name: "collect-index",
		components:{
			Foot,
			Header,
			TwiceTitle
		},
		data (){
			return {
				shop:[],
				loading:true,
				total:0,
				current_page:0,
				page:1,
				pagenum:[],
			}
		},
		created () {
			this.getShopList()
		},
		methods:{
			getShopList: function () {
				this.$get('/apis/discern/discernFavorite', {
					params: {
						uid:getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
						page:this.page,
					}
				}).then((res)=>{
					if(res){
						this.shop = res.data.data
						this.loading = false,
					// 分页参数
						this.pagenum=res.data
						this.total = res.data.total
						this.page = res.data.current_page
					}
				})
			},
			changePage(currentPage){
				this.page = currentPage;
				this.getShopList();
				document.body.scrollTop = document.documentElement.scrollTop = 0
			},

		}
	}
</script>
<style>
	#knowcollect .container{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
	}
	#knowcollect .class-box{
		background:  #EDEDED;
		height: 158px;
	}
	#knowcollect .class-list{
		display: flex;
	}
	.none{
		text-align: center;
		color: #555;
		font-size: 18px;
		margin: auto;
		min-height: 400px;
	}
	#knowcollect .name{
		margin-top: 25px;
		margin-left: 13px;
	}
	#knowcollect .select{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
	}
	#knowcollect .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		margin-left: 20px;

	}
	#knowcollect .search-money{
		margin-top: 25px;
		margin-left: 20px;
	}
	#knowcollect .search-money input{
		border: 1px solid #d3d3d2;
		background: #EDEDED;
		width: 75px;
		height: 21px;
		font-size: 12px;
		text-align: center;
		border-radius: 2px;
	}
	#knowcollect .search-money span{
		color: #d3d3d2
	}
	#knowcollect .sort-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #f7f7f7;
		height: 42px;
		line-height: 42px;
		margin-top: 25px;
		margin-bottom:25px;
	}
	#knowcollect .sort-name{
		display: flex;
	}
	#knowcollect .sort-all{
		width: 135px;
		font-size: 12px;
		color: #979797;
		margin-left: 43px;
	}
	#knowcollect .sort-all img{
		width: 6px;
		height: 6px;
		padding-left: 5px;
	}
	#knowcollect .equipment{
		font-size: 12px;
		color: #979797;
		margin-right: 22px;
	}
	#knowcollect .first-sort{
		color: #F9BE04;
	}
	#knowcollect .vertical{
		background: #CECECE;
		width: 1px;
		height: 26px;
		margin-top: 8px;
	}
	#knowcollect .shop-details{
		display: flex;
		border:1px solid #f7f7f7;
		box-sizing: border-box;
		padding: 20px;
		margin-top: -1px;
	}
	#knowcollect .right-details{
		margin-left: 20px;
	}
	#knowcollect .right-details .title{
		font-size: 20px;
		color: #444444;
	}
	#knowcollect .star{
		display: flex;
		line-height: 17px;
		margin-top: 12px;
	}
	#knowcollect .star img{
		width: 13px;
		height: 13px;
	}
	#knowcollect .condition{
		font-size: 12px;
		color: #F9BE04;
		margin-left: 10px;
	}
	#knowcollect .address{
		font-size: 12px;
		color: #737373;
		margin-left: 15px;
	}
	#knowcollect .shop-describe{
		font-size: 12px;
		color: #2E2E2E;
		margin-top: 11px;
		height: 80px;
	}
	#knowcollect .money{
		font-size: 20px;
		color: #F9BE04;
	}
	#knowcollect .foot-box{
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
	#knowcollect .see-num{
		display: flex
	}
	#knowcollect .pic{
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #656565;
	}
	#knowcollect .pic img{
		width: 32px;
		height: 32px;
		border-radius: 16px;
	}
	#knowcollect .num{
		font-size: 12px;
		color: #656565;
		display: flex;
		align-items: center;
		margin-left:21px;
	}
	#knowcollect .num img{
		padding-right: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/knowshop/CollectIndex.vue